import { Button, Checkbox, Input, Popconfirm, Select, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";
import SelectAccounts from "./selectAccounts.js";

function UpCampaignFunction(props) {
  const [loading, setLoading] = useState(false);
  const [personal, setPersonal] = useState(true);
  const [checkExistedCampaign, setCheckExistedCampaign] = useState(false);
  const [includesKeyword, setIncludesKeyword] = useState(true);
  const [includesAds, setIncludesAds] = useState(true);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [sheetURL, setSheetURL] = useState('https://docs.google.com/spreadsheets/d/1Z6fNAX0R6dT0BfxRz6dmp33tDBw1gjI44UW245qn3g0/edit?gid=1828076987#gid=1828076987');
  const [sheetName, setSheetName] = useState('CAM_TRANG');
  const [mccId, setMccId] = useState('');
  const [mccList, setMccList] = useState([]);
  const [pages, setPages] = useState([]);
  
  const [messageApi, contextHolder] = message.useMessage();

  const create = async (profile) => {
    messageApi.info(`Profile: ${profile.name} >>> Up Campaign...`);
    let body = {
      profile: profile,
      mccList: mccList.length > 0 ? mccList : [mccId],
      checkExistedCampaign,
      includesKeyword: includesKeyword,
      includesAds: includesAds,
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName,
      }
    };
    let url = `${API_HOST}/api/account/up-campaign`;
    if(personal) {
      url = `${API_HOST}/api/account/up-campaign-personal`;
    }
    axios
      .post(url, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ UP campaign(Local) ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  const listPages = async() => {
    axios
    .post(`${API_HOST}/api/account/up-campaign-pages`, {sheetId: sheetURL.split('/d/')[1].split('/edit')[0]})
    .then((res) => {
      if(res.data) {
        setPages(res.data);
      }
    })
    .catch((e) => {
      console.log("🚀 ~ UP campaign(pages) ~ e:", e);
    });
  }

  useEffect(() => {
    let sheetName = localStorage.getItem('cam-sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('cam-sheetURL')
    if(sheetURL) {
      setSheetURL(sheetURL)
    }
    let checkExistedCampaign = localStorage.getItem('check-existed-campaign')
    if(checkExistedCampaign) {
      setCheckExistedCampaign(checkExistedCampaign == 'true');
    }
    
  }, [])

  const onOpenChange = (open) => {
    if (open) {
      listPages();
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Up Campaign"
        description={
          <>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <br />
            <Checkbox checked={personal} onChange={e => setPersonal(e.target.checked)}>
              Up TKCN
            </Checkbox>
            <br />
            {!personal &&
              <>
                <label>Nhập MCC ID (Nếu có nhiều TK MCC):</label><br />
                <Input style={{width: 300}}
                    placeholder="MCC ID"
                    onChange={(e) => setMccId(e.target.value ) }
                />
                <br />
                <SelectAccounts selectAccounts={profileModel?.selectAccounts}
                  onSelected={(selected) => setMccList(selected)}
                />
                <br />
              </>
            }
            <br />
              <Checkbox checked={checkExistedCampaign} onChange={e => {
                setCheckExistedCampaign(e.target.checked);
                localStorage.setItem('check-existed-campaign', `${e.target.checked}`);
              }}>
                Check Đã Có CAM -> Bỏ Qua
              </Checkbox>
              <br />
              <Checkbox checked={includesKeyword} onChange={e => setIncludesKeyword(e.target.checked)}>
                + Keyword
              </Checkbox>
              <br />
              <Checkbox checked={includesAds} onChange={e => setIncludesAds(e.target.checked)}>
                + Ads
              </Checkbox>
              <br />
              <br />
   
            <label>Sheet Link: </label>
            <br />
              <Input
                value={sheetURL}
                style={{ width: 200 }}
                placeholder="SheetName ..."
                onChange={(e) => {
                  setSheetURL(e.target.value);
                  localStorage.setItem('cam-sheetURL', e.target.value);
                }}
              />
              <br />
              <label>SheetName: </label>
              <br />
              <Select
                  mode={"multiple"}
                  maxCount={1}
                  style={{width: 200}}
                  value={sheetName}
                  allowClear
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn Trang ... "
                  onChange={(v) => {
                    setSheetName(v);
                    localStorage.setItem('cam-sheetName', v);
                  }}
                  options={pages?.map((page) => ({
                    label: page.title,
                    value: page.title,
                  }))}
                />
          </>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button type="default" loading={loading}>
          <b>Lên Campaign</b>
        </Button>
      </Popconfirm>
    </>
  );
}
export default UpCampaignFunction;
